import { postDocumentsReject } from '../../reject';

/**
 * POST 거절하기
 *
 * @deprecated This API is forwarded. Due to the path is changed in standardize-document-content
 * @see https://www.notion.so/modusign/bb8e24e723434ecc946dfecb85db5ee3#e6b23c34f39c4232991f9ed46f937121
 */
export function postDocumentsParticipantsRejection({
  documentId,
  message,
  participantId,
  workspaceId,
}: {
  documentId: string;
  message: string;
  participantId: string;
  workspaceId: string;
}) {
  return postDocumentsReject({
    documentId,
    message,
    participantId,
    workspaceId,
  });
}
